import { IAddress } from "../Model/Configuration/IAddress";
import { IItem } from "../Model/Storage/IItem";
import { Configuration } from "./Configuration";
import { asNonWhiteSpaceString, isString, joinNonEmpty } from "./String";

export function getAddress(item: IItem): string {
  const address = Configuration.getAddress();
  const { country } = address;

  return joinNonEmpty(
    [...getAddressLine(item, address), ...getCityPostalCode(item, address), asNonWhiteSpaceString(item[country])],
    `, `
  );
}

const extensionLineCountries = [`GB`];
function isExtensionLineCountry(countryCode: unknown): boolean {
  if (!isString(countryCode)) {
    return false;
  }
  return extensionLineCountries.includes(countryCode);
}

const cityPostalCodeCountries = [`GB`, `RU`];
function isCityPostalCodeCountry(countryCode: unknown): boolean {
  if (!isString(countryCode)) {
    return false;
  }
  return cityPostalCodeCountries.includes(countryCode);
}

function getAddressLine(item: IItem, addressConfig: IAddress): string[] {
  const { countryCode, addressLine, addressExtension } = addressConfig;
  return isExtensionLineCountry(item[countryCode])
    ? [asNonWhiteSpaceString(item[addressLine]), asNonWhiteSpaceString(item[addressExtension])]
    : [asNonWhiteSpaceString(item[addressExtension]), asNonWhiteSpaceString(item[addressLine])];
}

function getCityPostalCode(item: IItem, addressConfig: IAddress): string[] {
  const { countryCode, city, postalCode } = addressConfig;
  return isCityPostalCodeCountry(item[countryCode])
    ? [asNonWhiteSpaceString(item[city]), asNonWhiteSpaceString(item[postalCode])]
    : [asNonWhiteSpaceString(item[postalCode]), asNonWhiteSpaceString(item[city])];
}
